import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.1.0-alpha';

function norm(x){
  x=x||{};
  return Object.freeze({
    integrityState:x.integrityState||'INSUFFICIENT_DATA',
    readiness:x.readiness||'REVIEW',
    unresolvedCriticalGaps:Number.isFinite(x.unresolvedCriticalGaps)?Math.max(0,Math.floor(x.unresolvedCriticalGaps)):0,
    unresolvedConflicts:Number.isFinite(x.unresolvedConflicts)?Math.max(0,Math.floor(x.unresolvedConflicts)):0,
    staleCriticalEvidence:x.staleCriticalEvidence===true,
    contractErrors:Number.isFinite(x.contractErrors)?Math.max(0,Math.floor(x.contractErrors)):0,
    consistencyErrors:Number.isFinite(x.consistencyErrors)?Math.max(0,Math.floor(x.consistencyErrors)):0
  });
}

function gate(x){
  const n=norm(x),reasons=[];
  let state='PASS';

  if(n.integrityState==='BROKEN' || n.contractErrors>0 || n.consistencyErrors>0){
    state='BLOCK';
    reasons.push('research integrity is broken');
  } else if(n.unresolvedCriticalGaps>0){
    state='BLOCK';
    reasons.push('critical evidence gaps remain unresolved');
  } else if(n.unresolvedConflicts>0){
    state='REVIEW';
    reasons.push('verified or material evidence conflicts remain unresolved');
  } else if(n.staleCriticalEvidence){
    state='REVIEW';
    reasons.push('critical evidence is stale');
  } else if(['WEAK','INSUFFICIENT_DATA','REVIEW'].includes(n.integrityState)){
    state='REVIEW';
    reasons.push(`research integrity state is ${n.integrityState}`);
  }

  const readiness =
    state==='BLOCK' ? 'BLOCKED' :
    state==='REVIEW' && n.readiness==='READY_FOR_DECISION' ? 'REVIEW' :
    n.readiness;

  return Object.freeze({
    gateState:state,
    readiness,
    reasons:Object.freeze(reasons),
    companyQualityOverride:false,
    entryGateBypass:false,
    tradeSignal:false,
    capitalPermission:false,
    universalScore:null
  });
}

function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const clean={integrityState:'HEALTHY',readiness:'READY_FOR_DECISION'};

  ok('healthy integrity passes',gate(clean).gateState==='PASS');
  ok('healthy ready remains ready',gate(clean).readiness==='READY_FOR_DECISION');

  const broken=gate({...clean,integrityState:'BROKEN'});
  ok('broken integrity blocks',broken.gateState==='BLOCK');
  ok('broken integrity forces blocked readiness',broken.readiness==='BLOCKED');

  const critical=gate({...clean,unresolvedCriticalGaps:1});
  ok('critical gap blocks',critical.gateState==='BLOCK');
  ok('critical gap forces blocked readiness',critical.readiness==='BLOCKED');

  const conflict=gate({...clean,unresolvedConflicts:1});
  ok('unresolved conflict requires review',conflict.gateState==='REVIEW');
  ok('review downgrades ready to review',conflict.readiness==='REVIEW');

  const stale=gate({...clean,staleCriticalEvidence:true});
  ok('stale critical evidence requires review',stale.gateState==='REVIEW');

  const weak=gate({...clean,integrityState:'WEAK'});
  ok('weak integrity requires review',weak.gateState==='REVIEW');

  const insufficient=gate({...clean,integrityState:'INSUFFICIENT_DATA'});
  ok('insufficient data requires review',insufficient.gateState==='REVIEW');

  const contract=gate({...clean,contractErrors:1});
  ok('contract errors block',contract.gateState==='BLOCK');

  const consistency=gate({...clean,consistencyErrors:1});
  ok('consistency errors block',consistency.gateState==='BLOCK');

  ok('does not override Company Quality',broken.companyQualityOverride===false);
  ok('does not bypass Entry Gate',broken.entryGateBypass===false);
  ok('no trade signal',broken.tradeSignal===false);
  ok('no capital permission',broken.capitalPermission===false);
  ok('no universal score',broken.universalScore===null);

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

const API={VERSION,norm,gate,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestResearchIntegrityDecisionGate=Object.freeze(API);
})(engineContext);